export enum CvBoxAccessTokenStatus {
  Pending = 1,
  Active = 2,
  Rejected = 3,
  Terminated = 4,
  ReadOnly = 5,
  Expired = 6,
}
